import { Request, BaseApiUrl } from "./api";

// 列表获取所有车辆信息
export const getVehicleListPage = () => {
  return Request.get(`${BaseApiUrl}/api/ProdConsole/GetVehicle`, {});
};

// 获取任务单
export const getTaskListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdConsole/GetTask`, { params: params });
};
// 获取任务单生产信息
export const getProdConsoleListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdConsole/GetProdConsole`, { params: params });
};

// 获取出货单新增编辑基础数据
export const getGetProdOutMasterBaseData = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdOutMaster/GetProdOutMasterBaseData`);
};
//新增
export const addVehicleDispatch = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdConsole/VehicleDispatch`, params);
};


// 单据回站
export const putProdConsoleBackOutMaster = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdConsole/BackOutMaster?id=${params}`);
};
// 车辆回站
export const putackVehicle = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdConsole/BackVehicle?id=${params}`);
};
// 取消出货单调度 
export const putProdConsoleCancelOutMaster = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdConsole/CancelOutMaster?id=${params}`);
};
// 获取当班司机
export const getVehicleWorker = (params) => {
  return Request.get(`${BaseApiUrl}/api/VehicleWorker/get`, { params: params });
};
// 获取当前待排车辆信息
export const getWaitVehicle = () => {
  return Request.get(`${BaseApiUrl}/api/ProdConsole/GetWaitVehicle`);
};
// 取消出货单调度 
export const getLastOutMasterByVehicleId = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdConsole/GetLastOutMasterByVehicleId`,{ params: params });
};
//获取生产进度
export const getProdSchedule = (params) => {
  return Request.post(`${BaseApiUrl}/api/Prodmanufacturemain/GetProdSchedule`, params);
};

// //编辑
// export const editProdOutMaster = (params) => {
//   return Request.post(`${BaseApiUrl}/api/ProdOutMaster/ModifySave`, params);
// };
// //编辑
// export const singeProdOutMaster = (params) => {
//   return Request.post(`${BaseApiUrl}/api/ProdOutMaster/SingeOutMaster`, params);
// };

// // 获取出货单新增编辑基础数据
// export const getGetProdOutMasterBaseData = (params) => {
//     return Request.get(`${BaseApiUrl}/api/ProdOutMaster/GetProdOutMasterBaseData`);
//   };

// //批量删除
// export const batchDeleteProdOutMaster = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/ProdOutMaster/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
